import React from "react";
import styles from "./PinCheckbox.module.css";
import PropTypes from "prop-types";
import classNames from "classnames";

import { ReactComponent as PinIcon } from "../../assets/open-pin.svg";

/**
 * Interactive component.
 * Displays a checkbox with a pin icon when checked.
 */
export function PinCheckbox({ pinned, onClick }) {
  return (
    <div
      className={classNames(styles.container, pinned && styles.pinned)}
      onClick={() => onClick(!pinned)}
    >
      {pinned && (
        <div className={styles.pin}>
          <PinIcon />
        </div>
      )}
    </div>
  );
}

PinCheckbox.propTypes = {
  /**
   * Determines if the item is pinned or not.
   */
  pinned: PropTypes.bool,
  /**
   * Function called when the check box is clicked.
   */
  onClick: PropTypes.func,
};
